/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// font imports from fontsource
// see: https://www.gatsbyjs.com/docs/how-to/styling/using-web-fonts/
// and: https://www.gatsbyjs.com/docs/recipes/styling-css/#using-google-fonts
// and: https://github.com/fontsource/fontsource/tree/main/packages

import React from 'react'
import SimpleReactLightbox from 'simple-react-lightbox'
// USE THE IMPORT BELOW INSTEAD IF YOU ARE USING THE PRO VERSION
// import SimpleReactLightbox from 'simple-react-lightbox-pro'

// REMOVED: `import "@fontsource/open-sans"` and `import "@fontsource/lato"`.
// A bare @fontsource import pulls in the package's full CSS — every weight and
// every subset (latin, latin-ext, cyrillic, greek, vietnamese, …) — so webpack
// had to process dozens of woff2 files on each develop build. Neither family is
// referenced by a single `font-family` rule in this project; the fonts actually
// in use are Titillium Web, Raleway and Josefin Sans, all loaded via
// gatsby-plugin-google-fonts. If one of them is ever needed, import just the
// weight you want, e.g. `import "@fontsource/lato/400.css"`.

import "./src/styles/preloader.scss"

 // ES5 way
// exports.onClientEntry = () => {
// ES6 way
export const onClientEntry = () => {
    // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
    if (!(`IntersectionObserver` in window)) {
      import(`intersection-observer`)
      console.log(`# IntersectionObserver is polyfilled!`)
    }
}
// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => (
  <SimpleReactLightbox>{element}</SimpleReactLightbox>
)